<template>
<div class="content">
  <div class="page-inner">
    <section class="scrollable">
      <div class="bg-light">
        <h3 class="font-thin mt-0 mb-0">{{ $t('create_playlist') }}</h3>
      </div>
      <section class="mt-2 mb-5">
        <div class="card">
          <div class="card-body">
            <form class="form" @submit.prevent="createPlaylist">
              <div>
                <div class="form-group">
                  <label>{{ $t('genre') }}</label>
                  <select class="form-control" v-model="playlist.main_genre">
                    <option :value="genre" v-for="genre in genres" v-bind:key="genre">
                      {{ genre }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>URL</label>
                  <input v-model="playlist.url" type="url" class="form-control">
                  <div v-if="playlist.url && playlist.url.match(/playlist\//)" class="mt-2 alert alert-warning">
                    {{ $t('verify_link') }}: <a class="ml-2" :href="playlist.url" target="_blank">{{ $t('open_new_window') }} <i class="fa fa-external-link-alt"></i></a>
                  </div>
                  <div class="mt-2 alert alert-danger" v-if="playlist.url && !playlist.url.match(/playlist\//)">
                    {{ $t('invalid_channel_link') }}: <br/>
                    <a href="https://open.spotify.com/user/0prvlevxuj0z0qizh2o7zd5hy/playlist/4upW6GXuE1Cqzok1fnkOIN?si=Xvjv-FeNTLGe32yczJa9OQ" target="_blank">https://open.spotify.com/user/0prvlevxuj0z0qizh2o7zd5hy/playlist/4upW6GXuE1Cqzok1fnkOIN?si=Xvjv-FeNTLGe32yczJa9OQ</a>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ $t('cost_per_placement') }}</label>
                  <input class="form-control" v-model="playlist.cost_per_placement" type="number" min="100" max="1000">
                  <button v-bind:disabled="creating" type="submit" class="btn btn-primary mt-4">{{ $t('create_playlist') }}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
      <div class="mb-5"></div>
    </section>
  </div>
</div>
</template>
<script>
import genres from '../data/genres'
import _ from 'lodash'

export default {
  data: function () {
    return {
      genres: _.map(genres, (genre, key) => {
        return key
      }),
      creating: false,
      playlist: {
        main_genre: 'Alternative',
        cost_per_placement: 100
      },
      loading: true
    }
  },
  methods: {
    createPlaylist () {
      this.creating = true

      if (!this.playlist.url || !this.playlist.url.match(/\/playlist/)) {
        return
      }

      this.$http.post(`${window.apiURL}api/user/playlists`, this.playlist, { withCredentials: true }).then(response => {
        this.$notify({ message: this.$t('playlist_created') }, 'success', 'fa-check')
        this.$router.push('/user/playlists')
      }, (err, response) => {
        console.log('Error creating campaign', err)
        this.creating = false
      })
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CreatePlaylist.vue